var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHollowShare = function SvgHollowShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3057_12850)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M21.65 9.56 14 4.15a.8.8 0 0 0-.82-.06c-.26.14-.43.41-.43.7v2.49c-2.51.19-4.87 1.27-6.66 3.06A10.48 10.48 0 0 0 3 17.79v2.17c0 .44.36.79.79.79.35 0 .66-.24.76-.57l.08-.29c1.06-3.7 4.3-6.35 8.11-6.68v2.42c0 .3.16.57.43.7.26.14.58.12.82-.06l7.65-5.42c.21-.15.33-.39.33-.65s-.12-.5-.33-.65zm-8.11 2.02c-1.19 0-2.36.19-3.48.57-2.14.73-3.99 2.1-5.31 3.92.81-4.14 4.48-7.24 8.79-7.24.44 0 .79-.36.79-.79V6.32l5.49 3.88-5.49 3.89v-1.72c0-.44-.35-.79-.79-.79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3057_12850"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 4h18.98v16.75H3z"
  })))));
};
export default SvgHollowShare;